<template>
    <div class="card">
        <div class="card-body">
            <h4><span class="material-icons md-18 text-main-gradient">person_add</span> Nuevo Paciente (Creación Rápida)</h4>
            <p class="text-muted mt-2">Los campos marcados con <span class="text-danger">*</span> son opcionales.</p>
            <form @submit.prevent="crear_paciente">
                <div class="row">
                    <div class="col-md-6 mb-3">
                        <label class="form-label">Nombre completo</label>
                        <input type="text" class="form-control form-control-sm" v-model="nuevoPaciente.nombre" required>
                    </div>
                    <div class="col-md-6 mb-3">
                        <label class="form-label">Género</label>
                        <select class="form-control form-control-sm" v-model="nuevoPaciente.genero" required>
                            <option value="Masculino">Masculino</option>
                            <option value="Femenino">Femenino</option>
                            <option value="Otro">Otro</option>
                        </select>
                    </div>
                    <div class="col-md-6 mb-3">
                        <label class="form-label">Fecha de nacimiento</label>
                        <input type="date" class="form-control form-control-sm" v-model="nuevoPaciente.fecha_nacimiento" required>
                    </div>
                    <div class="col-md-6 mb-3">
                        <label class="form-label">Teléfono</label>
                        <input type="text" v-mask="'###-###-####'" class="form-control form-control-sm" v-model="nuevoPaciente.telefono" required>
                    </div>
                    <div class="col-md-6 mb-3">
                        <label class="form-label">Email <span class="text-danger">*</span></label>
                        <input type="email" class="form-control form-control-sm" v-model="nuevoPaciente.email">
                    </div>
                    <div class="col-md-6 mb-3">
                        <label class="form-label">Dirección <span class="text-danger">*</span></label>
                        <input type="text" class="form-control form-control-sm" v-model="nuevoPaciente.direccion" maxlength="100">
                    </div>
                    <div class="col-md-6 mb-3">
                        <label class="form-label">¿Tiene Seguridad Social?</label>
                        <select class="form-control form-control-sm" v-model="nuevoPaciente.tiene_seguridad_social" required>
                            <option :value="true">Sí</option>
                            <option :value="false">No</option>
                        </select>
                    </div>
                    <div class="col-md-6 mb-3" v-if="nuevoPaciente.tiene_seguridad_social">
                        <label class="form-label">Institución de Salud</label>
                        <select class="form-control form-control-sm" v-model="nuevoPaciente.institucion_salud" required>
                            <option value="IMSS">IMSS</option>
                            <option value="ISSSTE">ISSSTE</option>
                            <option value="PEMEX">PEMEX</option>
                            <option value="SEDENA">SEDENA</option>
                            <option value="SEMAR">SEMAR</option>
                            <option value="INSABI">INSABI</option>
                            <option value="IMSS-BIENESTAR">IMSS-BIENESTAR</option>
                            <option value="PRIVADO">PRIVADO</option>
                            <option value="OTRO">OTRO</option>
                            <option value="NINGUNA">NINGUNA</option>
                        </select>
                    </div>
                    <div class="col-md-12 text-center">
                        <vs-button type="submit" color="rgb(59,222,200)" gradient block>
                            💾 Guardar Paciente
                        </vs-button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
var config = require("@/config/api.json");
const API = config.api;

export default {
    name: "CrearPaciente",
    props: {
        // Cambiar prop currentUser por personal_medico_id
        personal_medico_id: {
            type: [Number, String], // Ajusta el tipo según sea necesario (Number o String)
            required: true
        }
        // ... otras props si existen ...
    },
    data() {
        return {
            nuevoPaciente: {
                nombre: '',
                genero: 'Masculino',
                fecha_nacimiento: '',
                telefono: '',
                email: '',
                direccion: '',
                tiene_seguridad_social: false,
                institucion_salud: 'NINGUNA'
            }
        };
    },
    methods: {
        resetForm() {
            this.nuevoPaciente = {
                nombre: '',
                genero: 'Masculino',
                fecha_nacimiento: '',
                telefono: '',
                email: '',
                direccion: '',
                tiene_seguridad_social: false,
                institucion_salud: 'NINGUNA'
            };
        },
        async crear_paciente() {
            // Asumiendo que vEmpty y vEmail están disponibles (global, mixin, props, etc.)
            // Si no, deberás implementar o importar estas validaciones aquí.
            if (!this.vEmpty(this.nuevoPaciente.nombre.trim(), 'Nombre')) return;
            if (!this.vEmpty(this.nuevoPaciente.fecha_nacimiento.trim(), 'Fecha de nacimiento')) return;
            if (this.nuevoPaciente.email && !this.vEmail(this.nuevoPaciente.email.trim())) {
                this.notify('error', 'Error: Email inválido');
                return;
            }
            if (!this.vEmpty(this.nuevoPaciente.telefono.trim(), 'Teléfono')) return;
            // Limpieza de datos opcionales
            if (!this.nuevoPaciente.email) {
                this.nuevoPaciente.email = '';
            }
            if (!this.nuevoPaciente.direccion) {
                this.nuevoPaciente.direccion = '';
            }
            // Lógica de seguridad social
            if (this.nuevoPaciente.institucion_salud === 'NINGUNA' && this.nuevoPaciente.tiene_seguridad_social) {
                this.nuevoPaciente.tiene_seguridad_social = false;
            }
            if (!this.nuevoPaciente.tiene_seguridad_social) {
                this.nuevoPaciente.institucion_salud = 'NINGUNA';
            }

            try {
                // Asumiendo que openLoading y closeLoading están disponibles
                this.openLoading();
                // Usar la prop personal_medico_id directamente
                if (this.personal_medico_id) {
                    this.nuevoPaciente.personal_medico_id = this.personal_medico_id;
                } else {
                    // Asumiendo que notify está disponible
                    this.notify('error', 'Error: ID de personal médico no proporcionado');
                    this.closeLoading();
                    return;
                }

                const response = await axios.post(`${API}/crear_paciente`, this.nuevoPaciente);

                if (response.data.status === 'success') {

                    await this.callAudit(this.nuevoPaciente.personal_medico_id,"CREAR","pacientes",this.nuevoPaciente.personal_medico_id, `Creación de paciente: ${this.nuevoPaciente.nombre}`);

                    // Asumiendo que notify está disponible
                    this.resetForm();
                    // Emitir evento para notificar al padre que se creó un paciente
                    this.$emit('pacienteCreado', response.data.paciente); // Opcional: pasar el paciente creado
                }
            } catch (error) {
                 // Asumiendo que notify está disponible
                this.notify('error', `Error: ${error.response?.data?.message || error.message}`);
            } finally {
                 // Asumiendo que closeLoading está disponible
                this.closeLoading();
            }
        }
    },
    // Si necesitas usar v-mask, asegúrate de registrar la directiva localmente o globalmente
    // directives: { mask } // Si la importas localmente
}
</script>

